module.exports = __webpack_public_path__ + "assets/font/MECHABREAKBOLD-1.08-321f1974.ttf";